import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { MobileOutlined, LockOutlined } from '@ant-design/icons';
import client from '../api/client';
import SmsCodeInput from '../components/SmsCodeInput';

export default function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const phoneNumber = Form.useWatch('phoneNumber', form) || '';

  const onFinish = async (values: { phoneNumber: string; smsCode: string; newPassword: string }) => {
    setLoading(true);
    try {
      await client.post('/auth/sms/reset-password', {
        phoneNumber: values.phoneNumber,
        smsCode: values.smsCode,
        newPassword: values.newPassword,
      });
      message.success('密码重置成功，请使用新密码登录');
      navigate('/login', { replace: true });
    } catch (err) {
      const msg =
        (err as { response?: { data?: { message?: string } } })?.response?.data?.message
        || (err as Error)?.message
        || '重置失败';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1a2e 100%)',
      }}
    >
      <Card
        title={
          <Typography.Title level={4} style={{ margin: 0, textAlign: 'center' }}>
            DTwince 云边智孪 · 重置密码
          </Typography.Title>
        }
        style={{ width: 400, background: '#1a1a2e', borderColor: '#333' }}
      >
        <Form form={form} onFinish={onFinish} size="large">
          <Form.Item
            name="phoneNumber"
            rules={[
              { required: true, message: '请输入手机号' },
              { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' },
            ]}
          >
            <Input prefix={<MobileOutlined />} placeholder="手机号" maxLength={11} />
          </Form.Item>
          <Form.Item name="smsCode" rules={[{ required: true, message: '请输入验证码' }]}>
            <SmsCodeInput scene="reset_password" phoneNumber={phoneNumber} />
          </Form.Item>
          <Form.Item
            name="newPassword"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 6, message: '密码长度至少 6 位' },
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="新密码（至少 6 位）" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 8 }}>
            <Button type="primary" htmlType="submit" loading={loading} block>
              重置密码
            </Button>
          </Form.Item>
          <div style={{ textAlign: 'center' }}>
            想起密码了？<a onClick={() => navigate('/login')}>返回登录</a>
          </div>
        </Form>
      </Card>
    </div>
  );
}